<template>
  <div>
    <div class="row">
      <div class="col-md-12">
        <div class="m-portlet m-portlet--tab">
          <div class="m-portlet__body">
            <div>
              <span class="loading-request" v-show="loading"></span>
              <div
                class="d-flex justify-content-between flex-wrap flex-md-nowrap align-items-center pb-2 mb-4 border-bottom"
              >
                <h1 class="h2">Contratos</h1>
                <div class="btn-toolbar mb-2 mb-md-0">
                  <div class="btn-group btn-group-sm" role="group" aria-label="Menu dos contratos">
                    <span
                      class="btn btn-outline-brand mr-2"
                      @click="openReadjustmentContract('add')"
                      v-b-tooltip.hover
                      title="Reajustar valores dos contratos!"
                    >
                      <i class="far fa-pen-nib"></i>&nbsp; Reajustar Contratos
                    </span>
                  </div>
                  <div class="btn-group btn-group-sm" role="group" aria-label="Menu dos contratos">
                    <span
                      class="btn btn-outline-brand"
                      @click="openSaveContract('add')"
                      v-b-tooltip.hover
                      title="Novo contrato!"
                    >
                      <i class="fas fa-plus-square"></i>&nbsp; Cadastrar
                    </span>
                  </div>
                </div>
              </div>
              <div class="page-amounts">
                <nav aria-label="...">
                  <ul class="pagination pagination-md">
                    <li class="page-item" :class="{ selected: amount == 3 }">
                      <a @click="amount = 3" class="page-link paginate">3</a>
                    </li>
                    <li class="page-item" :class="{ selected: amount == 10 }">
                      <a @click="amount = 10" class="page-link paginate">10</a>
                    </li>
                    <li class="page-item" :class="{ selected: amount == 50 }">
                      <a @click="amount = 50" class="page-link paginate">50</a>
                    </li>
                    <li class="page-item" :class="{ selected: amount == 100 }">
                      <a @click="amount = 100" class="page-link paginate">100</a>
                    </li>
                    <li class="page-item" :class="{ selected: amount == 150 }">
                      <a @click="amount = 150" class="page-link paginate">150</a>
                    </li>
                  </ul>
                </nav>
              </div>
              <div class="paginator-info-top m-2">
                <span class="m--font-gray" v-if="data.from"
                  >Exibindo itens de {{ data.from }} a {{ data.to }}, de um total de
                  {{ data.total }}.</span
                >
                <span class="m--font-gray" v-else>Nenhum item a ser exibido.</span>
              </div>
            </div>
            <div class="table-responsive">
              <div class="container-table">
                <table class="table table-striped- table-bordered table-hover table-checkable">
                  <thead>
                    <tr>
                      <td
                        nowrap
                        class="text-center align-middle pointer"
                        width="60"
                        :class="{ 'table-sorted': sortType == 'customer_id' }"
                        @click="sortCall('customer_id')"
                      >
                        ID Cliente
                        <span
                          class="fas fa-caret-down sorted"
                          v-if="sortType == 'customer_id' && !sortReverse"
                        ></span>
                        <span
                          class="fas fa-caret-up sorted"
                          v-if="sortType == 'customer_id' && sortReverse"
                        ></span>
                        <span class="fal fa-sort sort" v-if="sortType != 'customer_id'"></span>
                      </td>
                      <td nowrap class="text-center align-middle" width="60">ID Contrato</td>
                      <td nowrap class="text-center align-middle" width="320">Cliente</td>
                      <td nowrap class="text-center align-middle" width="150">CNPJ</td>
                      <td nowrap class="text-center align-middle" width="100">Produto</td>
                      <td
                        nowrap
                        class="text-center align-middle pointer"
                        width="30"
                        :class="{ 'table-sorted': sortType == 'customer_id' }"
                        @click="sortCall('finish')"
                      >
                        Término
                        <span
                          class="fas fa-caret-down sorted"
                          v-if="sortType == 'finish' && !sortReverse"
                        ></span>
                        <span
                          class="fas fa-caret-up sorted"
                          v-if="sortType == 'finish' && sortReverse"
                        ></span>
                        <span class="fal fa-sort sort" v-if="sortType != 'finish'"></span>
                      </td>
                      <td nowrap class="text-center align-middle" width="80">Ações</td>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td>
                        <input
                          type="text"
                          class="form-control form-control-sm m-input"
                          @keypress="validateValueNumber"
                          v-model="filters.id"
                        />
                      </td>
                      <td>
                        <input
                          type="text"
                          class="form-control form-control-sm m-input"
                          @keypress="validateValueNumber"
                          v-model="filters.contractId"
                        />
                      </td>
                      <td>
                        <input
                          type="text"
                          class="form-control form-control-sm m-input"
                          v-model="filters.name"
                        />
                      </td>
                      <td>
                        <input
                          type="text"
                          class="form-control form-control-sm m-input"
                          v-model="filters.cnpj"
                        />
                      </td>
                      <td>
                        <SelectProducts
                          :selected="filters.product"
                          @change="setFilter('product', $event)"
                          class="form-control-sm"
                        />
                      </td>
                      <td class="text-center align-middle" nowrap>
                        <input
                          id="finish"
                          type="date"
                          ref="finish"
                          class="form-control form-control-sm col-md-11"
                          v-model="filters.finish"
                          value="1"
                          v-b-tooltip.hover
                          title="A partir de:"
                        />
                        <div class="form-check form-check-inline">
                          <input
                            class="form-check-input m-0"
                            type="checkbox"
                            id="expired"
                            v-model="filters.expired"
                          />
                          <label class="form-check-label form-control-sm" for="expired"
                            >Vencidos</label
                          >
                        </div>
                      </td>
                      <td class="text-center align-middle" nowrap>
                        <button
                          type="button"
                          class="btn btn-outline-brand btn-sm btn-outline-metal btn-sm mr-1"
                          @click="callData"
                          v-b-tooltip.hover
                          title="Clique para filtrar"
                        >
                          <i class="far fa-search"></i> Filtrar
                        </button>
                        <button
                          type="button"
                          class="btn btn-outline-brand btn-sm btn-outline-metal btn-sm"
                          @click="clearFilters"
                          v-b-tooltip.hover
                          title="Clique para limpar os filtros"
                        >
                          <i class="far fa-eraser"></i> Limpar
                        </button>
                      </td>
                    </tr>
                    <tr v-for="(contract, id) in data.data" :key="id">
                      <td class="text-center align-middle">{{ contract.customer.id }}</td>
                      <td class="text-center align-middle">{{ contract.id }}</td>
                      <td class="text-left align-middle">
                        {{ contract.customer.customerable.name }}
                      </td>
                      <td class="text-center align-middle">
                        {{ contract.customer.documents.value | cnpj | cpf }}
                      </td>
                      <td class="text-center align-middle">{{ contract.product.name }}</td>
                      <td nowrap class="text-center align-middle">{{ contract.finish | date }}</td>
                      <td nowrap class="text-center align-middle">
                        <a
                          href="#"
                          @click.prevent.stop="openSaveContract(contract.id)"
                          class="icon-circle ml-1"
                          v-b-tooltip.hover
                          title="Editar Contrato"
                        >
                          <i class="fas fa-pen-nib"></i>
                        </a>
                        <a
                          href
                          @click.prevent.stop="confirmDel(contract.id)"
                          class="icon-circle ml-1"
                          :class="{ disabled: contract.invoices.length > 0 }"
                          v-b-tooltip.hover
                          title="Delete"
                        >
                          <i class="fas fa-trash-alt"></i>
                        </a>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
            <div>
              <div class="paginator-info-bottom mt-2">
                <span class="m--font-gray" v-if="data.from"
                  >Exibindo itens de {{ data.from }} a {{ data.to }}, de um total de
                  {{ data.total }}.</span
                >
                <span class="m--font-gray" v-else>Nenhum item a ser exibido.</span>
              </div>
              <div class="paginator-list">
                <nav aria-label="...">
                  <ul class="pagination pagination-md">
                    <li class="page-item" :class="{ disabled: data.current_page == 1 }">
                      <a class="page-link paginate" @click="page = 1"
                        ><i class="fal fa-angle-double-left"></i
                      ></a>
                    </li>
                    <li class="page-item" :class="{ disabled: data.current_page == 1 }">
                      <a class="page-link paginate" @click="page = data.current_page - 1"
                        ><i class="fal fa-angle-left"></i
                      ></a>
                    </li>
                    <li
                      class="page-item"
                      :class="{ disabled: data.current_page == 1 }"
                      v-if="data.current_page > 2"
                    >
                      <a class="page-link paginate" @click="page = data.current_page - 2">
                        {{ data.current_page - 2 }}</a
                      >
                    </li>
                    <li
                      class="page-item"
                      :class="{ disabled: data.current_page == 1 }"
                      v-if="data.current_page > 1"
                    >
                      <a class="page-link paginate" @click="page = data.current_page - 1">
                        {{ data.current_page - 1 }}</a
                      >
                    </li>
                    <li class="page-item selected">
                      <a class="page-link paginate"> {{ data.current_page }} </a>
                    </li>
                    <li
                      class="page-item"
                      :class="{ disabled: data.current_page == data.last_page }"
                      v-if="data.current_page < data.last_page"
                    >
                      <a class="page-link paginate" @click="page = data.current_page + 1">
                        {{ data.current_page + 1 }}
                      </a>
                    </li>
                    <li
                      class="page-item"
                      :class="{ disabled: data.current_page + 1 == data.last_page }"
                      v-if="data.current_page + 1 < data.last_page"
                    >
                      <a class="page-link paginate" @click="page = data.current_page + 2">
                        {{ data.current_page + 2 }}
                      </a>
                    </li>
                    <li
                      class="page-item"
                      :class="{ disabled: data.current_page == data.last_page }"
                    >
                      <a class="page-link paginate" @click="page = data.current_page + 1"
                        ><i class="fal fa-angle-right"></i
                      ></a>
                    </li>
                    <li
                      class="page-item"
                      :class="{ disabled: data.current_page == data.last_page }"
                    >
                      <a class="page-link paginate" @click="page = data.last_page"
                        ><i class="fal fa-angle-double-right"></i
                      ></a>
                    </li>
                  </ul>
                </nav>
              </div>
            </div>
            <div class="pt-4"></div>
          </div>
        </div>
      </div>
      <transition name="slideleft" mode="out-in">
        <CustomerContractModal v-if="showContractSave" @updateList="callData" />
      </transition>
      <transition name="slideleft" mode="out-in">
        <CustomerContractReadjustment v-if="showContractReadjustment" @updateList="callData" />
      </transition>
      <transition name="fade" mode="out-in">
        <div
          class="m-quick-sidebar-overlay"
          v-if="showContractSave"
          @click="closeSaveContract()"
        ></div>
      </transition>
      <transition name="fade" mode="out-in">
        <div
          class="m-quick-sidebar-overlay"
          v-if="showContractReadjustment"
          @click="closReadjustmentContract()"
        ></div>
      </transition>
    </div>
  </div>
</template>

<script>
import CustomerContractReadjustment from '@/components/contracts/CustomerContractReadjustmentModal';
import CustomerContractModal from '@/components/contracts/CustomerContractModal';
import SelectProducts from '@/components/forms/SelectProducts';
import { returnMessageMixin } from '@/mixins/returnMessageMixin';
import { validationFilterValueMixin } from '@/mixins/validationFilterValueMixin';

import { baseApiUrl } from '@/global';
import axios from 'axios';

export default {
  mixins: [returnMessageMixin, validationFilterValueMixin],
  name: 'CustomerContracts',
  components: { CustomerContractReadjustment, CustomerContractModal, SelectProducts },
  data() {
    return {
      sortType: localStorage.customerContractsSortType
        ? localStorage.customerContractsSortType
        : 'customer_id',
      sortReverse: localStorage.customerContractsSortReverse
        ? JSON.parse(localStorage.customerContractsSortReverse)
        : false,
      amount: localStorage.customerContractsDataAmount
        ? localStorage.customerContractsDataAmount
        : 100,
      page: localStorage.customerContractsDataPage ? localStorage.customerContractsDataPage : 1,
      filters: {
        id: localStorage.customerContractsFilterId ? localStorage.customerContractsFilterId : '',
        name: localStorage.customerContractsFilterName
          ? localStorage.customerContractsFilterName
          : '',
        cnpj: localStorage.customerContractsFilterCnpj
          ? localStorage.customerContractsFilterCnpj
          : '',
        product: localStorage.customerContractsFilterProduct
          ? localStorage.customerContractsFilterProduct
          : '',
        finish: localStorage.customerContractsFilterFinish
          ? localStorage.customerContractsFilterFinish
          : '',
        expired: localStorage.customerContractsFilterExpired
          ? localStorage.customerContractsFilterExpired
          : false,
      },
      data: [],
    };
  },
  computed: {
    loading() {
      return !this.data.current_page;
    },
    showContractSave() {
      return this.$store.state.showContractSave;
    },
    showContractReadjustment() {
      return this.$store.state.showContractReadjustment;
    },
  },
  methods: {
    changeStatus(contractId) {
      const url = `${baseApiUrl}/v1/customer/contract/status/${contractId}`;
      axios(url)
        .then((res) => {
          this.logMessage(res);
          this.getDatas();
        })
        .catch((error) => {
          this.logMessageFailed(error.response);
        });
      this.callData();
    },
    setFilter(filterToChange, id) {
      this.filters[filterToChange] = id;
    },
    clearFilters() {
      this.filters.id = '';
      this.filters.contractId = '';
      this.filters.name = '';
      this.filters.cnpj = '';
      this.filters.product = '';
      this.sortType = 'customer_id';
      this.filters.sortReverse = false;
      this.filters.finish = '';
      this.filters.expired = false;
      this.callData();
    },
    setStorageFilters() {
      localStorage.setItem('customerContractsFilterId', this.filters.id);
      localStorage.setItem('customerContractsFilterContractId', this.filters.contractId);
      localStorage.setItem('customerContractsFilterName', this.filters.name);
      localStorage.setItem('customerContractsFilterCnpj', this.filters.cnpj);
      localStorage.setItem('customerContractsFilterProduct', this.filters.product);
      localStorage.setItem('customerContractsDataAmount', this.amount);
      localStorage.setItem('customerContractsDataPage', this.page);
      localStorage.setItem('customerContractsSortType', this.sortType);
      localStorage.setItem('customerContractsSortReverse', this.sortReverse);
      localStorage.setItem('customerContractsFilterFinish', this.filters.finish);
      localStorage.setItem('customerContractsFilterExpired', this.filters.expired);
    },
    convertFilters() {
      const filters = `?page=${this.page ? this.page : 1}&id=${
        this.filters.id ? this.filters.id : ''
      }&contractId=${this.filters.contractId ? this.filters.contractId : ''}
      &name=${this.filters.name ? this.filters.name : ''}&cnpj=${
        this.filters.cnpj ? this.filters.cnpj : ''
      }&product=${this.filters.product ? this.filters.product : ''}&amount=${
        this.amount
      }&sortType=${this.sortType}&finish=${this.filters.finish}&expired=${
        this.filters.expired
      }&sortOrder=${this.sortReverse ? 'DESC' : 'ASC'}`;
      return filters;
    },
    sortCall(sortType) {
      this.sortReverse = this.sortType == sortType ? !this.sortReverse : false;
      this.sortType = sortType;
    },
    callData() {
      const timeWindow = 700;
      clearTimeout(this.timeoutId);
      this.timeoutId = setTimeout(() => {
        this.data.current_page = 0;
        this.setStorageFilters();
        this.getDatas();
      }, timeWindow);
    },
    getDatas() {
      const url = `${baseApiUrl}/v1/customer/contract/search/${this.convertFilters()}`;

      axios(url).then((res) => {
        this.data = res.data;

        if (res.data.current_page > res.data.last_page) {
          this.page = 1;
        }
      });
    },
    confirmDel(id) {
      this.dialog = '';
      this.$bvModal
        .msgBoxConfirm('Tem certeza que deseja excluir o contrato selecionado?', {
          size: 'md',
          contentClass: 'p-3',
          bodyClass: 'modal-body-fix',
          buttonSize: 'md',
          okVariant: 'danger',
          okTitle: 'Confirmar exclusão',
          cancelTitle: 'Cancelar',
          cancelVariant: 'metal',
          footerClass: 'p-4',
          hideHeaderClose: true,
          centered: true,
        })
        .then((value) => {
          if (value == true) {
            this.del(id);
          }
        })
        .catch((error) => {
          this.logMessageFailed(error.response);
        });
    },
    del(id) {
      const url = `${baseApiUrl}/v1/customer/contract/delete/${id}`;
      axios
        .delete(url)
        .then((res) => {
          this.logMessage(res);
          this.getDatas();
        })
        .catch((error) => {
          this.logMessageFailed(error.response);
        });
    },
    openSaveContract(id) {
      this.$store.state.showContractSave = id;
    },
    openReadjustmentContract(id) {
      this.$store.state.showContractReadjustment = id;
    },
    closeSaveContract() {
      this.$store.state.showContractSave = null;
      this.callData();
    },
    closReadjustmentContract() {
      this.$store.state.showContractReadjustment = null;
      this.callData();
    },
  },
  watch: {
    amount() {
      if (this.page == 1) {
        this.callData();
      } else {
        this.page = 1;
      }
    },
    page() {
      this.callData();
    },
    sortType() {
      this.callData();
    },
    sortReverse() {
      this.callData();
    },
  },
  mounted() {
    this.getDatas();
    window.scroll(0, 0);
  },
};
</script>
